import { h } from 'preact'
import { useTranslations } from '../../hooks/useTranslations'
import DirectDebitIcon from '../../assets/icons/Direct-debit-logo.svg'
import styles from './DirectDebitGuarantee.module.scss'

const DirectDebitGuarantee = () => {
  const l10n = useTranslations()
  return (
    <section className={styles.directDebitGuarantee}>
      <header className={styles.directDebitGuarantee__header}>
        <h4
          className={styles.directDebitGuarantee__title}
          data-testid="guarantee-header"
        >
          {l10n.t('Direct Debit Guarantee')}
        </h4>
        <img
          src={DirectDebitIcon}
          alt={`Icon for DirectDebit`}
          data-testid="guarantee-logo"
        />
      </header>

      <ul
        className={styles.directDebitGuarantee__list}
        data-testid="guarantee-list"
      >
        <li>
          {l10n.t(
            'This Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits'
          )}
        </li>
        <li>
          {l10n.t(
            'NOTIFICATION_CHANGES_ACCOUNT'
          )}
        </li>
        <li>
          {l10n.t(
            'NOTIFICATION_REQUEST_TUI'
          )}
        </li>
        <li>
          {l10n.t(
            'NOTIFICATION_RECEIVE_REFUND'
          )}
        </li>
        <li>
          {l10n.t(
            'NOTIFICATION_CANCEL_DD'
          )}
        </li>
      </ul>
    </section>
  )
}

export default DirectDebitGuarantee
